import { constantTree } from "../../../core/events/ConstantTree";

export const bookingTree = constantTree({
  UpcomingPast: {
    TabDefaultChange: "",
    MonthFilter: {
      Click: ""
    },
    LoadMore: {
      Click: ""
    },
    Details: {
      Click: ""
    },
    srClaim: {
      Click: ""
    }
  },
  Ticket: {
    Init: "",
    Share: {
      Click: ""
    },
    Download: {
      Click: ""
    },
    Passenger: {
      PrevNextClick: ""
    },
    Offer: {
      Change: ""
    },
    MultiTicket: {
      Change: ""
    },
    Popup: {
      OpenClose: "",
      Close: ""
    }
  },
  RequestInvoice: {
    Popup: {
      OpenClose: "",
      Close: ""
    },
    Submit: {
      Click: ""
    }
  },
  Details: {
    GetBooking: {
      Init: ""
    },
    MultiBookingCancel: {
      Click: "",
      Confirm: ""
    },
    Status: {
      Get: ""
    },
    srClaim: {
      Click: ""
    },
    Help: {
      Click: ""
    },
    Unmount: "",
    ExpandCollapse: "",
    ShareTicket: {
      Click: ""
    },
  },
  QuickExchange: {
    Next: {
      Click: ""
    },
    Previous: {
      Click: ""
    },
    Cancel: "",
    Flow: {
      Close: ""
    }
  },
  BookItAgain: {
    Flow: {
      Close: ""
    },
  },
  BookReturnJourney: {
    Flow: {
      Close: ""
    }
  },
  AddToCalendar: {
    Click: ""
  },
  ManageSeating: {
    Flow: {
      Close: ""
    },
    Continue: {
      Click: ""
    },
    Redirect: {
      Click: ""
    }
  },
  RetrieveBooking: {
    AutoSuggestionList: {
      Get: ""
    },
    Button: {
      Click: ""
    },
    Fetch: {
      Click: ""
    },
    Modal: {
      Close: ""
    },
    OnChange: "",
    StartFrom: {
      Upcoming: ""
    },
    Check: {
      CashData: ""
    }
  },
  UpgradeToPremium: {
    Click: ""
  },
  AddShuttleTransfer: {
    Click: ""
  },
  OnHold: {
    Flow: {
      Close: ""
    },
    Pay: {
      Click: ""
    }
  },
  ticketOptions: {
    get: ""
  },
  seatingPreferences: {
    get: ""
  }
});